import type { GroundListQuery, SafeGround } from "@playarena/shared";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { GroundState } from "../../types/ground";

const initialState: GroundState = {
  grounds: [],
  selectedGround: null,
  filters: {},
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 12,
    hasNextPage: false,
    hasPrevPage: false,
  },
  isLoading: false,
  error: null,
};

const groundSlice = createSlice({
  name: "ground",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<GroundListQuery>) => {
      state.filters = action.payload;
    },
    clearFilters: state => {
      state.filters = {};
    },
    setSelectedGround: (state, action: PayloadAction<SafeGround | null>) => {
      state.selectedGround = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setPagination: (state, action: PayloadAction<GroundState["pagination"]>) => {
      state.pagination = action.payload;
    },
    setGrounds: (state, action: PayloadAction<SafeGround[]>) => {
      state.grounds = action.payload;
    },
    addGround: (state, action: PayloadAction<SafeGround>) => {
      state.grounds.unshift(action.payload);
    },
    updateGroundInList: (state, action: PayloadAction<SafeGround>) => {
      const index = state.grounds.findIndex(ground => ground.id === action.payload.id);
      if (index !== -1) {
        state.grounds[index] = action.payload;
      }
    },
    removeGroundFromList: (state, action: PayloadAction<string>) => {
      state.grounds = state.grounds.filter(ground => ground.id !== action.payload);
    },
  },
});

export const {
  setFilters,
  clearFilters,
  setSelectedGround,
  clearError,
  setLoading,
  setError,
  setPagination,
  setGrounds,
  addGround,
  updateGroundInList,
  removeGroundFromList,
} = groundSlice.actions;
export default groundSlice.reducer;
